import React, { Component } from 'react'
import * as actions from '../actions/TablaMovimientosMercaderiaActions'
import { connect } from 'react-redux'
import moment from 'moment'
import { formValueSelector, reduxForm } from 'redux-form'
import { FORM_TAREA_MOVIMIENTO } from '../../../../../config/forms'
import { INTERVALO_CORTO } from '../../../../../config/settings'
import { ToastContainer } from 'react-toastify'
import FormTareaMovimiento from '../../../../CuadroDeMandoMovimientos/components/FormTareaMovimiento'

const selector = formValueSelector(FORM_TAREA_MOVIMIENTO)
class UpdateTarea extends Component {
  componentDidMount () {
    const { tareaInicial, change: formChange } = this.props

    moment.locale()
    let fechaInicioDefault
    let horaInicioDefault
    console.log(tareaInicial)
    if (tareaInicial) {
      fechaInicioDefault = moment(tareaInicial.fechaDeInicio).format('YYYY/MM/DD')
      horaInicioDefault = moment(tareaInicial.fechaDeInicio).format('HH:mm:ss')
      console.log('fd', fechaInicioDefault)
      console.log('hd', horaInicioDefault)
      console.log('td', tareaInicial.tarea)
      formChange('tarea', tareaInicial.tarea)
      formChange('fechaInicio', fechaInicioDefault)
      formChange('horaInicio', horaInicioDefault)
    }
  }

  render () {
    const {
      handleSubmit,
      handleClose,
      tareas,
      tareaInicio,
      horaInicio,
      fechaInicio,
      tareaInicial
    } = this.props

    return (
      <div>
        <ToastContainer autoClose={INTERVALO_CORTO} />
        <div>
          {tareaInicial && horaInicio && fechaInicio && tareaInicio && <FormTareaMovimiento
            tareas={tareas}
            tareaInicio={tareaInicio}
            horaInicial={horaInicio}
            fechaInicial={fechaInicio}
            handleSubmit={handleSubmit}
            handleClose={handleClose}
          />
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    tareaInicial: state.cuadroDeMandoMovimientos.tareaInicial,
    tareaInicio: selector(state, 'tarea'),
    fechaInicio: selector(state, 'fechaInicio'),
    horaInicio: selector(state, 'horaInicio')
  }
}

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_TAREA_MOVIMIENTO,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(UpdateTarea))
